import AppConstants from 'constants/AppConstants';

/**
 * Fetch the business inventory for this service day
 * @param serviceDay The service day / business day for which we want the business inventory schedule
 */
export function fetchForServiceDay(serviceDay: string): ApiAction {
  return {
    TockApi: {
      getProto: `/business/inventory/serviceday/${serviceDay}`,
      type: AppConstants.CALENDAR_BUSINESS_INVENTORY_SCHEDULE_FETCH_FOR_SERVICE_DAY,
    },
  };
}
